import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Loading from '../Loading';
import './style.css';

// Components
import Auth from '../Auth';
import Dashboard from '../Dashboard';
import Pins from '../Pins';

@inject('AuthStore')
@observer
export default class App extends React.Component {
  render() {
    const { AuthStore } = this.props;
    const { loading, currentUser } = AuthStore;
    if (loading) {
      return (
        <Loading />
      );
    } else if (currentUser) {
      return (
        <Router>
          <Switch>
            <Route exact path="/login" render={() => <Redirect to="/dashboard" />} />
            <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
            <Route exact path="/dashboard" render={props => <Dashboard {...props} />} />
            <Route exact path="/pins" render={props => <Pins {...props} />} />
          </Switch>
        </Router>
      );
    }
    return (
      <Router>
        <Switch>
          <Route exact path="/login" render={props => <Auth {...props} />} />
          <Route path="/" render={() => <Redirect to="/login" />} />
        </Switch>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/index.js